import Vue from "vue";

const initialLoading = { status: false };

export const state = {
  status: null,
  loadingFinished: false,
};
export const mutations = {
  SET_LOADING_MESSAGE(state, newValue) {
    state.status = newValue;
  },
  SET_LOADING_FINISHED(state, value) {
    state.loadingFinished = value;
  },
};
export const actions = {
  async showLoading({ commit }, data = initialLoading) {
    commit("SET_LOADING_MESSAGE", data.status);
  },
  setLoadingFinished({ commit }, value) {
    commit("SET_LOADING_FINISHED", value);
  },
};

export default {
  state,
  mutations,
  actions,
};
